<template>
  <PlayerSpotlight
    playerName="BUCK O’NEIL"
    :reverse="true"
    :playerImages="[
      require('@/assets/images/galleries/BUCK/BUCK-SLIDER-01.jpg'),
      require('@/assets/images/galleries/BUCK/BUCK-SLIDER-02.jpg'),
      require('@/assets/images/galleries/BUCK/BUCK-SLIDER-03.jpg'),
      require('@/assets/images/galleries/BUCK/BUCK-SLIDER-04.jpg'),
    ]"
  >
    <div slot="primaryParagraph">
      <p>
        John “Buck” O’Neil spent 33 seasons (1956-88) in the Cubs organization
        as a scout, coach and instructor. A first baseman/manager for the Kansas
        City Monarchs, O’Neil was the manager of Ernie Banks and Gene Baker, the
        first two African Americans to play for the team when the two Kansas
        City players signed with the Cubs.
      </p>
      <p>
        O’Neil joined the Cubs as a scout after the 1955 season and over the
        next three decades, traveled the country scouting at predominately
        African American high schools and colleges. Among his signings were
        future Hall of Famers Lou Brock and Lee Smith as well as longtime major
        league players, George Altman, Oscar Gamble and Joe Carter. As a mentor,
        O’Neil was instrumental in the development of Hall of Famer and fellow
        beloved Cubbie, Billy Williams.
      </p>
      <p>
        After several seasons as a minor league and spring training instructor
        (in addition to his scouting duties), O’Neil was promoted to the Cubs’
        major league coaching staff in 1962 – becoming the first African
        American coach in MLB history.
      </p>
      <p>
        In 2006, he was posthumously awarded the Presidential Medal of Freedom.
        Two years later, he was honored by the National Baseball Hall of Fame
        with the creation of an award named in his honor - the Buck O'Neil
        Lifetime Achievement Award.
      </p>
    </div>
  </PlayerSpotlight>
</template>

<script>
import PlayerSpotlight from "@/components/global/PlayerSpotlight";

export default {
  name: "BuckONeil",
  components: {
    PlayerSpotlight,
  },
};
</script>
